import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { userid, currentTenant } from '../../../Common/Credentials.js';
import CategoryServices from '../CategoryServices.js';
import { Spinner } from 'react-bootstrap';
import Footer from '../../../Component/Footer'
import Header from '../../../Component/Header'
import Menu from '../../../Component/Menu'
import Breadcrumb from '../../../NewUI/NewComponents/Breadcrumb.jsx';

const NewCategorylvl2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  const [pagename] = useState(state.pagename || 'New Sub Category');
  const [catid] = useState(state.catid || '');
  const [category] = useState(state.category || '');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [loader, setLoader] = useState(false);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume');
      navigate('/');
    }
  }, [navigate]);

  const onSubmit = (values) => {
    setLoader(true);
    const addcategory = {
      name: name,
      category: catid,
      tenantid: currentTenant
    };
    CategoryServices.addCategorylvl2(addcategory)
      .then(() => navigate('/categorylvl2', { state: { id: catid }, replace: true }))
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate('/');
        }
        setMessage(e.response?.data?.message || 'Error');
        setLoader(false);
      });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.name || values.name.trim() === '') {
      errors.name = "Sub Category Name is Required";
    }
    return errors;
  };

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        {loader && (
          <div className="UI-loading-overlay">
            <div className="UI-spinner"></div>
          </div>
        )}

        <div className="UI-container">
            <div className="UI-header">
            <Breadcrumb breadcrumbs={[{name:"Home",path:"/inventory"},{name:"Category Level 2",path:"/categorylvl2"},{name:pagename,path:""}]}/>
              <div className="UI-header-content">
                <div>
                  <h1 className="UI-title">{pagename}</h1>
                  <p className="UI-subtitle">Create a new sub category</p>
                </div>
                <div className="UI-header-actions">
                  <button
                    onClick={() => navigate(-1)}
                    className={`UI-btn UI-btn-outline ${hovered === "back" ? "UI-btn-outline-hover" : ""}`}
                    style={{
                      backgroundColor: hovered === "back" ? "#4d4d4d" : "#ffffff",
                      color: hovered === "back" ? "#fff" : "#4d4d4d",
                      transform: hovered === "back" ? "scale(1.02)" : "scale(1)",
                      border: '1px solid #4d4d4d',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={() => setHovered("back")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    ← Back
                  </button>
                </div>
              </div>
            </div>
            <div className="UI-form-card">
              <Formik
                initialValues={{ name, category }}
                onSubmit={onSubmit}
                validateOnChange={false}
                validate={validate}
                enableReinitialize
              >
                {() => (
                  <Form autoComplete="off">
                    <div className="UI-form-section">
                      {/* <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>
                        Sub Category Details
                      </h3> */}
                      <div className="UI-form-grid">
                        {/* Main Category (read-only) */}
                        <div className="UI-form-group">
                          <label className="UI-label">Main Category</label>
                          <input
                            type="text"
                            className="UI-input UI-input-disabled"
                            value={category}
                            disabled
                          />
                        </div>

                        {/* Sub Category Name */}
                        <div className="UI-form-group">
                          <label className="UI-label">Sub Category Name *</label>
                          <input
                            type="text"
                            name="name"
                            className={`UI-input ${message ? 'UI-input-error' : ''}`}
                            placeholder="Enter sub category name"
                            value={name}
                            onChange={(e) => { setName(e.target.value); setMessage(''); }}
                          />
                          {message && <div className="UI-error-text">{message}</div>}
                        </div>
                      </div>
                    </div>

                    <div className="UI-btn-actions">
                      <Link
                        to={{ pathname: '/categorylvl2' }}
                        state={{ id: catid }}
                        className={`UI-btn UI-btn-outline ${hovered === "cancel" ? "UI-btn-outline-hover" : ""}`}
                        style={{
                          backgroundColor: hovered === "cancel" ? "#4d4d4d" : "#ffffff",
                          color: hovered === "cancel" ? "#fff" : "#4d4d4d",
                          transform: hovered === "cancel" ? "scale(1.03)" : "scale(1)",
                          border: '1px solid #4d4d4d',
                          cursor: 'pointer',
                          textDecoration: 'none',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseEnter={() => setHovered("cancel")}
                        onMouseLeave={() => setHovered(null)}
                      >
                        Cancel
                      </Link>
                      <button
                        type="submit"
                        disabled={loader}
                        className={`UI-btn UI-btn-primary ${hovered === "submit" ? "UI-btn-primary-hover" : ""}`}
                        style={{
                          opacity: loader ? 0.6 : 1,
                          transform: hovered === "submit" ? "scale(1.07)" : "scale(1)",
                        }}
                        onMouseEnter={() => setHovered("submit")}
                        onMouseLeave={() => setHovered(null)}
                      >
                        {loader ? <><Spinner animation="border" size="sm" /> Saving...</> : 'Save'}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NewCategorylvl2;